export default __webpack_public_path__ + "static/hwtechnologievideo-a31066576111ceb20201c9025ca71b4b.mp4";